export enum BmBarcodeTextMode {
  Text = "Text",
  Scanner = "Scanner",
  Laser = "Laser",
}

export function stripUrlPartsFromBarcode(urlString: string): string {
  try {
    const url = new URL(urlString);
    if (url.protocol === "http:" || url.protocol === "https:") {
      urlString = url.pathname;
      urlString = urlString.substring(urlString.lastIndexOf("/") + 1);
    }
    return urlString;
  } catch (_) {
    // Ignore non-urls
    return urlString;
  }
}
